export default "__VITE_ASSET__BncS$CdI__"